import QRCode from "react-qr-code";

// Load Container with all the relevant pieces for the page component to load
export default function QRGeneratorCode() {
    const site_id = "test-string";
    return <QRCode value={site_id.toString()} fgColor="#019e3a" />;
}
